import { gql, useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";

const CANCEL_PRODUCTION_PLAN = gql`
  mutation ($planId: ID!, $cancelLaterPlans: Boolean!) {
    cancelProductionPlan(planId: $planId, cancelLaterPlans: $cancelLaterPlans) {
      productionPlan {
        id
        state
      }
    }
  }
`;

const CancelPlanView = ({ onCompleted, plan }) => {
  const [cancelPlan, cancelPlanRes] = useMutation(CANCEL_PRODUCTION_PLAN, {
    onCompleted() {
      Alert("success", "Plan is Canceled.");
      if (onCompleted) onCompleted();
    },
    onError(error) {
      Alert("error", error.message);
    },
  });

  return (
    <div className="text-sm">
      <div className="space-y-2">
        <p>Are you sure to cancel this plan? </p>
        <p>
          Canceling plans will release the stock and production dates usages. If
          you want to only cancel this plan, later plans dates might change due
          to stock and production usage.
        </p>
        <p>This will only effect plans in the current queue.</p>
      </div>

      <hr />

      <div>
        {cancelPlanRes.loading ? (
          <InlineSpinner size={27} text="Canceling Plan..." />
        ) : (
          <div className="flex space-x-6">
            <Button
              danger
              loading={cancelPlanRes.loading}
              onClick={() =>
                cancelPlan({
                  variables: {
                    planId: plan.id,
                    cancelLaterPlans: false,
                  },
                })
              }
            >
              Cancel only this plan
            </Button>
            <Button
              danger
              onClick={() =>
                cancelPlan({
                  variables: {
                    planId: plan.id,
                    cancelLaterPlans: true,
                  },
                })
              }
            >
              Cancel this plan and all the later plans
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelPlanView;
